<template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{ form.id ? 'Update Setting' : 'Create New Setting' }}
            </h4>
          </div>
          <div class="card-body">
           
            <div class="form-group">
              <label>Name</label>
              <ValidationProvider name="name" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'name is required' : null" :hasSuccess="passed"
                  name="name" v-model="form.name">
                </fg-input>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>Type</label>
              <ValidationProvider name="type">
                <el-select v-model="form.type">
                  <el-option :value="0" label="JSON"></el-option>
                  <el-option :value="1" label="STRING"></el-option>
                </el-select>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <label>Data</label>
              <ValidationProvider name="data" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'data is required' : null" :hasSuccess="passed"
                  name="data" v-model="form.data">
                </fg-input>
              </ValidationProvider>

              <!-- {{ JSON.parse(form.data) }} -->
            </div>
        
          </div>
          <div class="card-footer text-right">
            <p-button type="info" native-type="submit">Save</p-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </template>
  <script>
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import { Setting } from '@/resources/setting'

  extend("required", required);
  
  export default {
    props: ['setting'],
    data() {
      return {
        form: {
          name: "",
          data: ""
        },
        loading: false
      };
    },
    watch: {
      setting: function () {
        if (this.setting) {
            this.form = Object.assign({}, this.setting)
            // this.form.data = JSON.stringify(this.setting.data);
        }
      }
    },
    created: function () {
      if (this.setting) {
        this.form = Object.assign({}, this.setting)
        if (typeof this.setting.data === 'object' && this.setting.data !== null && !Array.isArray(this.setting.data)) {
          this.form.data = JSON.stringify(this.setting.data);
        }
      }
    },
    beforeDestroy() {
      this.form = {
        name: "",
      }
    },
    methods: {
      submit() {  
        this.loading = true
        let payload =  Object.assign({}, this.form)
        
        let request = payload.id ? Setting.update(payload.id, payload) : Setting.create(payload)
        
        request
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Setting has been saved',
            });
            this.$emit('save', true)
          })
          .catch(error => {
        
          }).finally(() => {
            this.loading = false
          })
      }
    }
  }
  </script>
  <style></style>
  